import { Box } from "@mui/material";
import PkCommonBar from "./PkCommonBar";
export function PkCommonHeader(props) {
  return (
    <Box sx={props.hero ? {} : { backgroundColor: "white" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <PkCommonBar
          title={`login`}
          color={props.color}
        />
      </Box>
      {props.hero ? null : (
        <Box
          sx={{
            p: "2rem",
            width: "100%",
            backgroundColor: "#000",
            backgroundImage: (theme) =>
              `linear-gradient(0.25turn, ${theme.palette.grey[700]} 50%, ${theme.palette.grey[400]} 50%, ${theme.palette.grey[400]} 75%, #fbe080 75%)`,
          }}
        ></Box>
      )}
    </Box>
  );
}
